import { useQuery, type UseQueryResult } from 'react-query';
import { PptSchemaService } from '../../services/wealthlane-customer-services/services/PptSchemaService';
import {
  normalizePptBSchemaResponse,
  type PptBExtraFieldsSchemaResponse,
} from '../../pages/onboarding/partBExtraFields';

const PART_B_EXTRA_FIELDS_QUERY_KEY = 'pptBSchema';

const useGetPartBExtraFields = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  options?: { enabled?: boolean }
): UseQueryResult<PptBExtraFieldsSchemaResponse | undefined, unknown> => {
  return useQuery(
    [PART_B_EXTRA_FIELDS_QUERY_KEY],
    async () => {
      const fromApi = await handleRequest(PptSchemaService.getApiCustomerApiAppPptSchema('ppt-b'));
      if (fromApi != null && Array.isArray(fromApi)) {
        return normalizePptBSchemaResponse(fromApi);
      }
      return { fields: [] };
    },
    {
      enabled: options?.enabled ?? true,
      staleTime: 5 * 60 * 1000,
    }
  );
};

export default useGetPartBExtraFields;
